import { render, staticRenderFns } from "./IconCard.vue?vue&type=template&id=4dd1acea"
var script = {}
import style0 from "./IconCard.vue?vue&type=style&index=0&id=4dd1acea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports